import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, unref as _unref, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "margin-b-standard" }
const _hoisted_3 = ["value"]
const _hoisted_4 = { class: "margin-b-standard" }
const _hoisted_5 = ["disabled"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "pb-2" }
const _hoisted_8 = { class: "pb-0 externalId" }

import { computed, onMounted, onUnmounted, PropType, ref, watch } from "vue";
import Collapse from "@/components/right-sidebars/ui/Collapse.vue";
import RightSidebarTitle from "@/components/right-sidebars/ui/RightSidebarTitle.vue";
import { ProductSection } from "@/models/product-section.model";
import { mdiContentSave } from "@mdi/js";
import { useContentStore } from "@/stores/content.store";
import { SECTION } from "@/constants/assets.constant";
import ErrorMessage from "@/components/ErrorMessage.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ContentIdentifiers',
  props: {
  productId: {
    required: true
  },
  internalId: {
    required: true,
    type: Number
  },
  externalId: {
    required: true,
    type: String
  },
  sections: {
    required: true,
    type: Array as PropType<ProductSection[]>
  },
  canEditContent: {
    required: true,
    type: Boolean
  }
},
  setup(__props) {

const contentStore = useContentStore();

const props = __props;

const newExternalId = ref<string>("");
onMounted(() => {
  newExternalId.value = props.externalId;
});
onUnmounted(() => {
  newExternalId.value = "";
});
watch(
  () => props.internalId,
  () => {
    newExternalId.value = props.externalId;
  }
);
watch(
  () => newExternalId.value,
  () => {
    externalIdError.value = "";
  }
);

const externalIdError = ref<string>("");
const isExternalIdValid = (): boolean => {
  externalIdError.value = "";
  return !props.sections.some((section: ProductSection) => {
    return (
      section.client_external_id === newExternalId.value &&
      section.id !== props.internalId
    );
  });
};
const updateExternalId = (): void => {
  let isValid;
  if (newExternalId.value) {
    // if a user entered the external id, this id must be unique
    isValid = isExternalIdValid();
  } else {
    // user can send empty string if he wants to remove the old external id and doesn't set a new one
    isValid = newExternalId.value !== props.externalId;
  }
  if (isValid) {
    contentStore
      .upsertSections({
        productIds: [Number(props.productId)],
        sections: [
          {
            id: props.internalId,
            client_external_id: newExternalId.value
          }
        ]
      })
      .catch((error: Error) => {
        externalIdError.value = error.message;
      });
  } else {
    externalIdError.value = SECTION.ERRORS.nonUniqueExternalId;
  }
};

const isSaveButtonDisabled = computed<boolean>(() => {
  return newExternalId.value === props.externalId || !!externalIdError.value;
});

return (_ctx: any,_cache: any) => {
  const _component_SVGIcon = _resolveComponent("SVGIcon")!

  return (_openBlock(), _createBlock(Collapse, null, {
    title: _withCtx(() => _cache[1] || (_cache[1] = [
      _createElementVNode("span", null, "Identifiers", -1)
    ])),
    content: _withCtx(() => [
      (__props.canEditContent)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(RightSidebarTitle, { title: 'Thoth id' }),
              _createElementVNode("input", {
                type: "text",
                readonly: "",
                disabled: "",
                value: __props.internalId
              }, null, 8, _hoisted_3)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createVNode(RightSidebarTitle, { title: 'External id' }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((newExternalId).value = $event))
              }, null, 512), [
                [
                  _vModelText,
                  newExternalId.value,
                  void 0,
                  { trim: true }
                ]
              ])
            ]),
            _createElementVNode("button", {
              class: "btn-3",
              onClick: updateExternalId,
              disabled: isSaveButtonDisabled.value
            }, [
              _createVNode(_component_SVGIcon, { path: _unref(mdiContentSave) }, null, 8, ["path"]),
              _cache[2] || (_cache[2] = _createTextVNode(" Save "))
            ], 8, _hoisted_5),
            (externalIdError.value)
              ? (_openBlock(), _createBlock(ErrorMessage, {
                  key: 0,
                  message: externalIdError.value
                }, null, 8, ["message"]))
              : _createCommentVNode("", true)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("p", _hoisted_7, [
              _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Thoth id: ", -1)),
              _createTextVNode(_toDisplayString(__props.internalId), 1)
            ]),
            _createElementVNode("p", _hoisted_8, [
              _cache[4] || (_cache[4] = _createElementVNode("strong", null, "External id: ", -1)),
              _createTextVNode(" " + _toDisplayString(__props.externalId), 1)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})